import {useMutation} from "@tanstack/react-query";
import {AnalyzeSearchParamType} from "../interface";
import moment from "moment";
import {downloadFile} from "../../../../../util/FileDownload";
import {exportInventoryAnalysisExcel} from "../../../../../api/inventory/AnalyzeApi";

export const useExportInventoryAnalysisExcel = () => {
    const {mutate} = useMutation({
        mutationFn: (data: AnalyzeSearchParamType) => exportInventoryAnalysisExcel(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                const now = moment().format("YYYY_MM_DD_hh_mm")

                downloadFile(res, `재고_분석_목록_${now}.xlsx`)
            }
        },
    });

    return {mutate};
};
